import React, {Component} from "react";
import {connect} from "react-redux";
import Table from "../../components/Table";
import UserItem from "./UserItem";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {fromJS, List} from "immutable";
import {graphql} from "react-apollo";
import {LIST_USERS, ON_NEW_USER} from "../../queries/users";
import update from "immutability-helper";

class UsersList extends Component {

  UNSAFE_componentWillMount() {
    // this.props.subscribeToNewCustomers(this.props, {}); 
  }

  render() {
    let {loading, error, users} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />

    let tableHeader = List([
      "User ID",
      "Name",
      "State",
    ]);

    return (
      <Table 
        data={fromJS(users)}
        tableHeader={tableHeader}
        renderer={UserItem} 
        onItemClick={this.handleItemClick.bind(this)}
        itemKey="userId"
        showCount={true}
        selected={this.props.selectedUserId}
        />
    )
  }

  handleItemClick(itemData, e, field = "") {
    let id = itemData.get("userId");
    if (field === "id") {
      e.stopPropagation();
      this.props.onCustomerIdClick(id);
      return;
    }
    this.props.onSelectionChange(id);
  }  
}

const mapDispatchToProps = dispatch => ({
  subscribeToNewCustomers: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_NEW_USER,
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) {
          return prev;
        }
        return update(prev, {
          users: {
            $push: [subscriptionData.data.newUser]
          }
        })
      }
    })
  }
})

const withSubscription = connect(mapDispatchToProps, mapDispatchToProps);

const withQuery = graphql(LIST_USERS, {
  options: {
    fetchPolicy: "network-only"
  }
})

export default withQuery(withSubscription(UsersList));